import type { MockMessage } from "@/dummy";

/**
 * Input for the `sendVisitorMessage` mutation behind a launcher-peek quick reply. Mirrors the
 * in-thread chip tap: the button's `value` rides along with the label (the BE resumes a flow by
 * value) and the peeked thread's key keeps the reply on THAT thread, not the main chat.
 */
export function peekSendInput(
  text: string,
  payload: string,
  threadKey: string | null,
): { text: string; buttonValue: string; threadKey?: string } {
  return { text, buttonValue: payload, ...(threadKey ? { threadKey } : {}) };
}

/** The visitor's optimistic bubble for a peek tap, so the opened conversation shows it at once. */
export function peekVisitorBubble(id: string, text: string): MockMessage {
  return {
    id,
    clientKey: id,
    direction: "INBOUND",
    text,
    ageLabel: "now",
    sender: { kind: "visitor", name: "" },
    deliveryStatus: "SENT",
  };
}
